import React from 'react'

const TabsList = (props: any) => {
    return <ul className="tabs__list">{props.children}</ul>;

}

export default TabsList